import React, { useState } from "react";
import { Link } from "react-router-dom";

const FAQ = () => {
  const [openItems, setOpenItems] = useState({});

  const toggleItem = (index) => {
    setOpenItems((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const faqCategories = [
    {
      category: "General Information",
      icon: "ℹ️",
      questions: [
        {
          question: "1. What is the Newsmedia Association of India (NAI)?",
          answer:
            "NAI is a prestigious national-level news media organization and association dedicated to empowering local voices and ensuring the visibility of ground realities across India and International coverage.",
        },
        {
          question: "2. What is the 'Citizen Reporter' program?",
          answer:
            "Established in 2013, the Citizen Reporting Platform is an initiative of the Newsmedia Association of India, empowering citizens to report and share news from their communities.\n\nCitizen Reporting and Citizen Journalism have brought forward another dimension of the media. It has emerged by breaking away from the boundaries of traditional media. It is a people's media platform.\n\nIn India, any citizen or organization can share with the world the news, incidents, and local events they witness in their surroundings without relying on any media organization or newspaper. No specific educational qualification or professional journalism experience is required for this.\n\nPrime Minister Narendra Modi also highlighted the importance of Citizen Reporting in his speech. He said that every citizen with a mobile phone is a partner in nation-building. This vision inspires the Citizen Reporting Program, which empowers ordinary people to report local issues, success stories, and emergencies.",
        },
        {
          question: "3. Who is the National President of Newsmedia Association of India?",
          answer:
            "The organization is headed by National President A. Charles, who has been serving as the Chief Editor of Police News Plus since 2013. Earlier, in 2007, he began his media career as the Chief Editor of Indhiya Sudar, a print newspaper.",
        },
        {
          question: "4. What is 'Police News Plus'?",
          answer:
            "India's first-of-its-kind Police News platform is recognized as the No.1 brand in India dedicated to promoting positive news about the Police. It is a digital media initiative under the NAI umbrella aligned with supporting the Indian Government and the Police Department through transparent reporting. It focuses on covering positive news about the Police and serves as a bridge between the public and the Police to build strong and healthy relationships.",
        },
        {
          question: "5. Police News Plus is a No.1 Brand?",
          answer:
            "Yes. India's first-of-its-kind Police News platform is recognized as the No.1 brand in India dedicated to promoting positive news about the Police since 2013.",
        },
        {
          question: "6. Is NAI a government body?",
          answer:
            "No. NAI is an independent national media association registered under the legal framework of the Government of India as a Section 8 company under the Companies Act, Ministry of Corporate Affairs.",
        },
      ],
    },
    {
      category: "Membership & Leadership",
      icon: "👥",
      questions: [
        {
          question: "7. How does NAI support the 'Digital India' mission?",
          answer:
            "NAI supports the mission by promoting paperless governance and e-governance through digital journalism, reducing dependency on paper files and physical waste.",
        },
        {
          question: "8. What are the benefits of the 'Go Green Journalism' initiative?",
          answer:
            "This initiative protects the environment by shifting from print to digital news, which prevents the daily cutting of trees for paper production and helps reduce global warming.",
        },
        {
          question: "9. Can I work as an NAI representative without a traditional office?",
          answer:
            "Yes. NAI offers a turnkey business model that allows leaders to operate without the burden of traditional business overheads or office rent, using the organization's existing brands and systems.",
        },
        {
          question: "10. Do I need a physical office to work as a member / leader?",
          answer:
            "No. NAI provides a 'turnkey business model' where leaders can operate using the organization’s brand and systems without the requirement for traditional office infrastructure, anywhere and any time they can operate.",
        },
      ],
    },
    {
      category: "Legal & Accreditation",
      icon: "⚖️",
      questions: [
        {
          question: "12. Does NAI have an RNI (Registrar of Newspapers for India) certificate?",
          answer:
            "While the organization holds RNI certificates for print titles such as Friends of Police and Indhiya Sudar, it has transitioned entirely to digital news to support environmental sustainability and the 'Digital India' vision, helping to reduce global warming.",
        },
        {
          question: "13. Do I need an MoU with the Police Department to work with 'Police News Plus'?",
          answer:
            "No. Under Article 19(1)(a) of the Indian Constitution, the media has the right to report on police activities without a formal MoU or partnership deed.",
        },
        {
          question: "14. Is a Government Gazette notification required for NAI leaders?",
          answer:
            "No. Gazette notifications are typically for government-notified bodies or RNI-registered print newspapers, not for independent media associations.",
        },
        {
          question: "15. Does an NAI ID card grant 'official' government power?",
          answer:
            "The ID card provides internal membership identity within a private national media association. It does not grant state-level government authority or PIB accreditation.",
        },
      ],
    },
    {
      category: "Registration & Documentation",
      icon: "📝",
      questions: [
        {
          question: "16. What documents are required to join?",
          answer:
            "Applicants must submit a passport-size photo, a copy of their Aadhaar card, their signature, and a mobile number.",
        },
        {
          question: "17. How is my appointment officially sanctioned?",
          answer:
            "Appointments are approved by the Central Committee members, following which a sanctioned leadership ticket or order is issued.",
        },
        {
          question: "19. Are digital signatures accepted for registration?",
          answer:
            "The registration process requires the submission of your signature along with official identification documents for record-keeping.",
        },
        {
          question: "20. Can I receive a physical appointment letter?",
          answer:
            "Yes. Upon successful appointment, members receive a physical appointment letter along with their leadership credentials.",
        },
      ],
    },
    {
      category: "The Leadership Kit & Tools",
      icon: "🛠️",
      questions: [
        {
          question: "21. What is included in the Leadership Kit?",
          answer:
            "The kit typically includes digital and physical ID cards, car stickers, posters, and official appointment documents.",
        },
        {
          question: "22. Will I get a visiting card?",
          answer:
            "Yes. Leaders receive professional visiting card designs featuring their name, designation, and a digital QR code for easy verification.",
        },
        {
          question: "23. Can I put 'PRESS' or 'MEDIA' on my vehicle?",
          answer:
            "Yes. NAI provides stickers. NAI recommends using 'MEDIA' as it is a broader umbrella term covering digital news and broadcasting.",
        },
        {
          question: "24. Is the ID card legally valid?",
          answer:
            "Yes. Every registered media organization in India has the legal right to issue its own Media ID cards to its members and reporters.",
        },
      ],
    },
    {
      category: "Digital vs. Print Media",
      icon: "📱",
      questions: [
        {
          question: "26. Why does NAI focus on Digital News?",
          answer:
            "Digital news offers instant global reach, zero printing costs, and is environmentally friendly as it saves millions of trees from being cut for paper production.",
        },
        {
          question: "27. Is print media declining in India?",
          answer:
            "According to NAI's assessment, digital consumption is exploding while print is declining; over 99% of people now access news via digital platforms like WhatsApp, Instagram and Facebook.",
        },
        {
          question: "28. Does digital journalism have the same rights as print?",
          answer:
            "Yes. The constitutional right to freedom of speech and expression applies equally to digital journalists and citizen reporters.",
        },
        {
          question: "29. What is 'Go Green Journalism'?",
          answer:
            "It is NAI’s commitment to adopting paperless, digital-first media practices to combat global warming and support climate goals.",
        },
        {
          question: "30. How do readers interact with digital news?",
          answer:
            "Digital news allows for 'one-touch' interaction, including features like 'click to call,' 'click to WhatsApp,' and 'click to email'.",
        },
      ],
    },
    {
      category: "Rights & Responsibilities",
      icon: "🛡️",
      questions: [
        {
          question: "31. Can I report on crime and social issues?",
          answer:
            "Yes. Citizen reporters are encouraged to communicate local issues and incidents directly to strengthen democracy and promote transparency.",
        },
        {
          question: "32. Can the police stop me from reporting in public?",
          answer:
            "No. The Supreme Court has held that police cannot stop lawful reporting in public places unless security is directly threatened.",
        },
        {
          question: "34. Can I attend VIP or Government events?",
          answer:
            "For high-security events, you must follow official protocols and send a formal request for entry, which is subject to security clearance and department approval.",
        },
        {
          question: "35. What is the code of conduct for NAI members?",
          answer:
            "Members are expected to act with truth, integrity, and a commitment to national progress through responsible journalism.",
        },
        {
          question: "40. Can I cancel my leadership post after it is sanctioned?",
          answer:
            "Once a post is sanctioned by the Central Committee, cancellation or conversion to a lower membership tier is generally not permitted under association guidelines.",
        },
      ],
    },
    {
      category: "Advanced Tools & Branding",
      icon: "🚀",
      questions: [
        {
          question: "41. Can I get a nameplate for my home?",
          answer:
            "Yes. The organization provides designs for door name boards featuring the NAI logo and your specific designation.",
        },
        {
          question: "42. Can I design my own NAI branded materials?",
          answer:
            "You may create customized designs (like digitized boards), but you must obtain official approval from the central office before production to ensure content accuracy.",
        },
        {
          question: "45. Does NAI provide training for reporters?",
          answer:
            "Presidents are empowered to guide, train, and build strong reporting teams across their assigned Areas.",
        },
      ],
    },
    {
      category: "Frequently Asked Technical Questions",
      icon: "❓",
      questions: [
        {
          question: "47. What is the 'Digital Identity' for journalists?",
          answer:
            "It refers to the QR-code-enabled credentials and digital identity tools that allow journalists to be verified instantly by government and public sectors.",
        },
        {
          question: "48. How do I reach the NAI official website?",
          answer:
            "The official website is www.naiindia.in.",
        },
        {
          question: "49. Is there a helpdesk for further clarifications?",
          answer:
            "Yes. If you have any doubts, you can contact the National President or the central committee directly via the provided WhatsApp contact numbers.",
        },
        {
          question: "50. What is the organization’s vision for the future?",
          answer:
            "NAI aims to realize a national dream where every village in India has a voice, contributing to a stronger, more connected, and transparent nation.",
        },
      ],
    },
  ];

  const additionalResources = [
    {
      title: "Media Types Guide",
      description:
        "Learn about different types of media and their roles in society",
      link: "/media-types",
    },
    {
      title: "Journalism History",
      description: "Explore the evolution of journalism through the ages",
      link: "/journalism-history",
    },
    {
      title: "Digital Media Trends",
      description: "Stay updated with current trends in digital journalism",
      link: "/digital-trends",
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section 
        className="relative bg-indigo-900 text-white py-20 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: "url('/images/faq.webp')" }}
      >
        <div className="absolute inset-0 bg-indigo-900/80"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">
              Frequently Asked Questions
            </h1>
            <p className="text-xl md:text-2xl text-indigo-100 max-w-4xl mx-auto">
              Your Comprehensive Guide to Media, Journalism, and NAI Services
            </p>
          </div>
        </div>
      </section>

      {/* Introduction */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Media Knowledge Base
            </h2>
            <div className="w-24 h-1 bg-indigo-600 mx-auto rounded-full"></div>
          </div>

          <div className="prose prose-lg max-w-none text-gray-700 text-center">
            <p className="text-lg leading-relaxed mb-6">
              Find answers to common questions about media, journalism, and the
              Newsmedia Association of India. Our comprehensive FAQ section
              covers everything from basic media concepts to current industry
              trends.
            </p>
          </div>
        </div>
      </section>

      {/* FAQ Categories */}
      <section className="py-20 bg-indigo-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              FAQ Categories
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Explore questions organized by topic for easy navigation
            </p>
            <div className="w-24 h-1 bg-indigo-600 mx-auto mt-6 rounded-full"></div>
          </div>

          <div className="space-y-12">
            {faqCategories.map((category, categoryIndex) => (
              <div
                key={categoryIndex}
                className="bg-white rounded-2xl shadow-lg overflow-hidden"
              >
                {/* Category Header */}
                <div className="bg-gradient-to-r from-indigo-600 to-indigo-700 p-6">
                  <div className="flex items-center justify-center mb-4">
                    <div className="text-3xl mr-4">{category.icon}</div>
                    <h3 className="text-2xl font-bold text-white">
                      {category.category}
                    </h3>
                  </div>
                </div>

                {/* Questions & Answers */}
                <div className="p-6">
                  <div className="space-y-4">
                    {category.questions.map((item, itemIndex) => {
                      const globalIndex = `${categoryIndex}-${itemIndex}`;
                      const isOpen = openItems[globalIndex];

                      return (
                        <div
                          key={itemIndex}
                          className="border border-gray-200 rounded-lg hover:shadow-md transition-shadow duration-300"
                        >
                          <button
                            onClick={() => toggleItem(globalIndex)}
                            className="w-full px-6 py-4 text-left flex justify-between items-center bg-gray-50 hover:bg-gray-100 transition-colors duration-200 rounded-lg"
                          >
                            <span className="text-lg font-semibold text-gray-900 pr-4">
                              {item.question}
                            </span>
                            <svg
                              className={`w-5 h-5 text-indigo-600 transform transition-transform duration-300 ${
                                isOpen ? "rotate-180" : ""
                              }`}
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M19 9l-7 7-7-7"
                              />
                            </svg>
                          </button>

                          <div
                            className={`overflow-hidden transition-all duration-300 ${
                              isOpen
                                ? "max-h-[1000px] opacity-100"
                                : "max-h-0 opacity-0"
                            }`}
                          >
                            <div className="px-6 py-4 bg-white">
                              <p className="text-gray-700 leading-relaxed whitespace-pre-line">
                                {item.answer}
                              </p>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Quick Stats */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Media Industry Insights
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Key statistics and trends in the evolving media landscape
            </p>
            <div className="w-24 h-1 bg-indigo-600 mx-auto mt-6 rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {[
              {
                stat: "2013",
                label: "Citizen Reporter Program",
                description: "Empowering citizens to report local news and realities",
              },
              {
                stat: "99%+",
                label: "Digital Reach",
                description: "Over 99% of people now consume news via digital platforms",
              },
              {
                stat: "Go Green",
                label: "Zero Paper Waste",
                description: "Committed to digital-first journalism to save trees",
              },
              {
                stat: "Sec 8",
                label: "Independent Association",
                description: "Registered national media association under MCA, Govt of India",
              },
            ].map((item, index) => (
              <div key={index} className="text-center">
                <div className="bg-indigo-100 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl font-bold text-indigo-600">
                    {item.stat}
                  </span>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  {item.label}
                </h3>
                <p className="text-sm text-gray-600">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Additional Resources */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Additional Resources
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Explore more about media and journalism with our curated resources
            </p>
            <div className="w-24 h-1 bg-indigo-600 mx-auto mt-6 rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {additionalResources.map((resource, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-6 hover:shadow-lg transition-shadow duration-300 border border-gray-200 text-center"
              >
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {resource.title}
                </h3>
                <p className="text-gray-600 mb-4">{resource.description}</p>
                <a
                  href={resource.link}
                  className="inline-flex items-center text-indigo-600 hover:text-indigo-700 font-semibold"
                >
                  Learn More
                  <svg
                    className="w-4 h-4 ml-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M14 5l7 7m0 0l-7 7m7-7H3"
                    />
                  </svg>
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Search & Contact Section */}
      <section className="py-20 bg-gradient-to-r from-indigo-600 to-indigo-700 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white bg-opacity-10 rounded-2xl p-8 backdrop-blur-sm">
            <div className="text-center mb-8">
              <h2 className="text-3xl font-bold mb-4">
                Can't Find Your Answer?
              </h2>
              <p className="text-indigo-100 text-lg">
                We're here to help with any additional questions you might have
              </p>
              <div className="w-24 h-1 bg-white mx-auto mt-4 rounded-full"></div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div>
                <h3 className="text-xl font-bold mb-4 flex items-center">
                  <span className="text-2xl mr-3">🔍</span>
                  Search Our Knowledge Base
                </h3>
                <div className="flex">
                  <input
                    type="text"
                    placeholder="Search for answers..."
                    className="flex-1 px-4 py-3 rounded-l-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  />
                  <button className="bg-indigo-800 hover:bg-indigo-900 px-6 py-3 rounded-r-lg font-semibold transition-colors duration-300">
                    Search
                  </button>
                </div>
              </div>

              <div>
                <h3 className="text-xl font-bold mb-4 flex items-center">
                  <span className="text-2xl mr-3">💬</span>
                  Contact Support
                </h3>
                <ul className="space-y-2 text-indigo-100">
                  <li className="flex items-center">
                    <span className="text-green-300 mr-2">•</span>
                    Email: mail@naiindia.in
                  </li>
                  <li className="flex items-center">
                    <span className="text-green-300 mr-2">•</span>
                    Phone: 72000 24451
                  </li>
                  <li className="flex items-center">
                    <span className="text-green-300 mr-2">•</span>
                    WhatsApp: 72000 24452
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-gray-900 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">
            Join the Newsmedia Association of India
          </h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto text-gray-300">
            Become part of India's premier media association and access
            exclusive resources, training, and networking opportunities.
          </p>
          <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-6">
            <Link to='/apply' className="bg-indigo-600 hover:bg-indigo-700 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-colors duration-300">
              Apply for Membership
            </Link>
            <button className="border-2 border-white hover:bg-white hover:text-gray-900 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-colors duration-300">
              Download Media Guide
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
